import * as html_extract from './html-extract';
import * as http_request from './http-request';
import * as graphql from './graphql';

export const webNodes = {
  'htmlExtract': html_extract,
  'http-request': http_request,
  'graphql': graphql,
};
